/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmissionEvaluationAnyOf } from './submissionEvaluationAnyOf';

export type SubmissionEvaluation = SubmissionEvaluationAnyOf | null;
